import { alpha } from "@mui/material/styles";
import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()(theme => ({
  page: {
    display: "flex",
    minHeight: "100%",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  card: {
    width: "100%",
    maxWidth: 480,
    margin: "auto",
    borderRadius: 12,
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${alpha(theme.palette.grey[500], 0.2)}`,
    boxShadow: `0 1px 3px ${alpha(theme.palette.grey[500], 0.3)}`,
  },
  header: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: theme.spacing(3.5),
    paddingLeft: theme.spacing(3.5),
    paddingRight: theme.spacing(3.5),
  },
  headerTitle: {
    fontWeight: 700,
    fontSize: 20,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    borderBottom: `1px solid ${theme.palette.grey[500_24]}`,
    alignSelf: "stretch",
    textAlign: "center",
  },
  body: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    padding: theme.spacing(3.5),
  },
}));
